module.exports = __webpack_public_path__ + "static/media/elektroninis-parasas.c0707b32.png";